module.exports = __webpack_public_path__ + "static/media/Icons_link-circle.f48f7bf7.svg";